import { useMemo } from "react";

import useLocalStorage from "./useLocalStorage";
import { ApiCompetition, ApiRoute } from "../types";

type Params = {
  competition?: ApiCompetition;
  route?: ApiRoute;
};

export default function useCategorySelection({ competition, route }: Params) {
  const [selectedCategoryUUIDs, setSelectedCategoryUUIDs] = useLocalStorage<
    string[]
  >(`${competition?.uuid}/selectedCategories`, []);

  const availableCategoryUUIDs = useMemo(
    () =>
      route?.competitionRouteGroups.map((x) => x.categories || []).flat() || [],
    [route]
  );

  const availableCategories = useMemo(() => {
    return (
      competition?.stages[0]?.categories.filter((x) =>
        availableCategoryUUIDs?.includes(x.uuid)
      ) || []
    );
  }, [competition, availableCategoryUUIDs]);

  const selectedCategories = useMemo(
    () =>
      availableCategories.filter((cat) =>
        selectedCategoryUUIDs.includes(cat.uuid)
      ) || [],
    [availableCategories, selectedCategoryUUIDs]
  );

  return {
    availableCategoryUUIDs,
    availableCategories,
    selectedCategories,
    selectedCategoryUUIDs,
    setSelectedCategoryUUIDs,
  };
}
